import { IApiSmpGptAgent } from "@smp/api/src/smp/gpt/agent/agent.types";
import { DeepNonNullable } from "@smp/utils";

export const INITIAL_AGENT_PARAMS_CONTEXT: DeepNonNullable<
  IApiSmpGptAgent["params"]
>["context"] = {
  niche: "",
  occupation: "",
  target_audience: "",
  problem: "",
  usp: "",
  benefits: "",
  goal: "",
  key_messages: "",
  avoided_topics: "",
  sample: "",
};
